<script>
import ListingModel from "@/views/Absence/AbsenceRequest/Components/ListingModel.vue";

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel :vacation="false" intranet/>
</template>